import { connect } from 'react-redux';
import { onOpen } from './events/onOpen';
import { onDidMount } from './events/onDidMount';
import { ICustomPropertiesPushToGoogleCalendarHOCProps } from './types';
import { IApplicationState } from 'app/types/types';
import { getBoardIdByCardId } from '../../../../../../../store/model/selectors/getBoardIdByCardId';
import { ESettingsSectionType } from '../../../../../base/components/SettingsSection/types';
import {
    CustomPropertiesPushToGoogleCalendar
} from '../../components/CustomPropertiesPushToGoogleCalendar/CustomPropertiesPushToGoogleCalendar';
import {
    ICustomPropertiesPushToGoogleCalendarEvents,
    ICustomPropertiesPushToGoogleCalendarFields
} from '../../components/CustomPropertiesPushToGoogleCalendar/types';
import { getCardCalendarCustomEvents } from '../../../../../../../store/model/selectors/getCardCalendarCustomEvents';
import { getSectionType } from '../../../../../aside_panel/cardDetails/selectors/getSectionType';
import { showBoardLimitSnackbarIfNeeded } from '../../../../../aside_panel/effects/showBoardLimitSnackbarIfNeeded';
import {
    getUserCommentsColumnView
} from '../../../../../../../store/model/authUser/selectors/getUserCommentsColumnView';

const mapStateToProps = (
    state: IApplicationState,
    { cardId, id, isSelectItem }: ICustomPropertiesPushToGoogleCalendarHOCProps
): ICustomPropertiesPushToGoogleCalendarFields => {
    const calendarEvents = getCardCalendarCustomEvents(state, cardId);
    const sectionType = getSectionType(state, getBoardIdByCardId(state, cardId), cardId);
    return {
        isColumnView: getUserCommentsColumnView(state),
        isDatePushed: !!calendarEvents.find(item => item.type === id),
        isReadonly: sectionType === ESettingsSectionType.READONLY,
        isSelectItem
    }
};
const mapDispatchToProps = (
    dispatch: any,
    { cardId }: ICustomPropertiesPushToGoogleCalendarHOCProps
): ICustomPropertiesPushToGoogleCalendarEvents => {
    return {
        onOpen: () => dispatch(onOpen()),
        onDidMount: () => dispatch(onDidMount(cardId)),
        onShowBoardLimitSnackbarIfNeeded: () => dispatch(showBoardLimitSnackbarIfNeeded()),
    }
};

export const CustomPropertiesPushToGoogleCalendarHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomPropertiesPushToGoogleCalendar);

CustomPropertiesPushToGoogleCalendarHOC.displayName = 'CustomPropertiesPushToGoogleCalendarHOC';
